import { Injectable } from '@angular/core';
import { EventService, RoutingService, SearchboxService, TranslationService, WindowRef } from '@spartacus/core';
import { SearchBoxComponentService, SearchBoxConfig } from '@spartacus/storefront';
import { SearchPagesService } from '../../content-pages/search-pages/core/search-pages.service';

@Injectable({
  providedIn: 'root',
})
export class CustomSearchBoxComponentService extends SearchBoxComponentService {
  constructor(
    private _searchService: SearchboxService,
    private _routingService: RoutingService,
    private _translationService: TranslationService,
    private _winRef: WindowRef,
    private _eventService: EventService,
    private searchPagesService: SearchPagesService,
  ) {
    super(_searchService, _routingService, _translationService, _winRef, _eventService);
  }

  override search(query: string, config: SearchBoxConfig): void {
    if (!query || query === '') {
      this.clearResults();
      return;
    }

    if (config.minCharactersBeforeRequest && query.length < config.minCharactersBeforeRequest) {
      return;
    }

    if (config.displayProducts) {
      this.searchService.search(query, {
        pageSize: config.maxProducts,
      });

      this.searchPagesService.fetch(query, 0);
    }

    if (config.displaySuggestions) {
      this.searchService.searchSuggestions(query, {
        pageSize: config.maxSuggestions,
      });
    }
  }
}
